export const notificationAudio = new Audio("/NotificationSound.mp3");
